// source: elwa_v1.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.ev24.protobuf.elwa_v1.E24EuoFindRequest', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.E24FindRequest', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.E24UserSupportRequest', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudFieldDef', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudLiteResponse', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudLoginRequest', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudLunaToken', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudRefreshRequest', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudReportDef', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudRequest', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudRequestDashboards', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudResponse', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudResponseDashboards', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudTokenResponse', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudUiDashboard', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudUiDisplay', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudUserFeedback', null, global);
goog.exportSymbol('proto.ev24.protobuf.elwa_v1.EudUserSupport', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.E24FindRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.E24FindRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.E24FindRequest.displayName = 'proto.ev24.protobuf.elwa_v1.E24FindRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.E24EuoFindRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.displayName = 'proto.ev24.protobuf.elwa_v1.E24EuoFindRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudRequest.displayName = 'proto.ev24.protobuf.elwa_v1.EudRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest.displayName = 'proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudLoginRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudLoginRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudLoginRequest.displayName = 'proto.ev24.protobuf.elwa_v1.EudLoginRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudRefreshRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudRefreshRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudRefreshRequest.displayName = 'proto.ev24.protobuf.elwa_v1.EudRefreshRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudResponse.displayName = 'proto.ev24.protobuf.elwa_v1.EudResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudLunaToken = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudLunaToken, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudLunaToken.displayName = 'proto.ev24.protobuf.elwa_v1.EudLunaToken';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ev24.protobuf.elwa_v1.EudTokenResponse.repeatedFields_, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudTokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudTokenResponse.displayName = 'proto.ev24.protobuf.elwa_v1.EudTokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.repeatedFields_, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.displayName = 'proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudLiteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudLiteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudLiteResponse.displayName = 'proto.ev24.protobuf.elwa_v1.EudLiteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.displayName = 'proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.displayName = 'proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.displayName = 'proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.displayName = 'proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.repeatedFields_, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.displayName = 'proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.displayName = 'proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.displayName = 'proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.displayName = 'proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudRequestDashboards = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudRequestDashboards, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudRequestDashboards.displayName = 'proto.ev24.protobuf.elwa_v1.EudRequestDashboards';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudUiDisplay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudUiDisplay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudUiDisplay.displayName = 'proto.ev24.protobuf.elwa_v1.EudUiDisplay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudFieldDef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudFieldDef.displayName = 'proto.ev24.protobuf.elwa_v1.EudFieldDef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudReportDef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ev24.protobuf.elwa_v1.EudReportDef.repeatedFields_, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudReportDef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudReportDef.displayName = 'proto.ev24.protobuf.elwa_v1.EudReportDef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ev24.protobuf.elwa_v1.EudUiDashboard.repeatedFields_, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudUiDashboard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudUiDashboard.displayName = 'proto.ev24.protobuf.elwa_v1.EudUiDashboard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ev24.protobuf.elwa_v1.EudResponseDashboards.repeatedFields_, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudResponseDashboards, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudResponseDashboards.displayName = 'proto.ev24.protobuf.elwa_v1.EudResponseDashboards';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest.displayName = 'proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudUserFeedback, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudUserFeedback.displayName = 'proto.ev24.protobuf.elwa_v1.EudUserFeedback';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.displayName = 'proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.EudUserSupport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.EudUserSupport.displayName = 'proto.ev24.protobuf.elwa_v1.EudUserSupport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ev24.protobuf.elwa_v1.E24UserSupportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.displayName = 'proto.ev24.protobuf.elwa_v1.E24UserSupportRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.E24FindRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.E24FindRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.E24FindRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24FindRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pagingMap: (f = msg.getPagingMap()) ? f.toObject(includeInstance, undefined) : [],
    queryMap: (f = msg.getQueryMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.E24FindRequest}
 */
proto.ev24.protobuf.elwa_v1.E24FindRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.E24FindRequest;
  return proto.ev24.protobuf.elwa_v1.E24FindRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.E24FindRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.E24FindRequest}
 */
proto.ev24.protobuf.elwa_v1.E24FindRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getPagingMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 2:
      var value = msg.getQueryMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.E24FindRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.E24FindRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.E24FindRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24FindRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagingMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getQueryMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * map<string, string> paging = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.ev24.protobuf.elwa_v1.E24FindRequest.prototype.getPagingMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.E24FindRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24FindRequest.prototype.clearPagingMap = function() {
  this.getPagingMap().clear();
  return this;
};


/**
 * map<string, string> query = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.ev24.protobuf.elwa_v1.E24FindRequest.prototype.getQueryMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.E24FindRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24FindRequest.prototype.clearQueryMap = function() {
  this.getQueryMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.E24EuoFindRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    token: jspb.Message.getFieldWithDefault(msg, 2, ""),
    actor: jspb.Message.getFieldWithDefault(msg, 3, ""),
    payload: (f = msg.getPayload()) && proto.ev24.protobuf.elwa_v1.E24FindRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.E24EuoFindRequest}
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.E24EuoFindRequest;
  return proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.E24EuoFindRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.E24EuoFindRequest}
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setActor(value);
      break;
    case 4:
      var value = new proto.ev24.protobuf.elwa_v1.E24FindRequest;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.E24FindRequest.deserializeBinaryFromReader);
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.E24EuoFindRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ev24.protobuf.elwa_v1.E24FindRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24EuoFindRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string token = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24EuoFindRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string actor = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.prototype.getActor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24EuoFindRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.prototype.setActor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional E24FindRequest payload = 4;
 * @return {?proto.ev24.protobuf.elwa_v1.E24FindRequest}
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.prototype.getPayload = function() {
  return /** @type{?proto.ev24.protobuf.elwa_v1.E24FindRequest} */ (
    jspb.Message.getWrapperField(this, proto.ev24.protobuf.elwa_v1.E24FindRequest, 4));
};


/**
 * @param {?proto.ev24.protobuf.elwa_v1.E24FindRequest|undefined} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24EuoFindRequest} returns this
*/
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.prototype.setPayload = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.E24EuoFindRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.prototype.clearPayload = function() {
  return this.setPayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.E24EuoFindRequest.prototype.hasPayload = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    token: jspb.Message.getFieldWithDefault(msg, 2, ""),
    payloadMap: (f = msg.getPayloadMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudRequest}
 */
proto.ev24.protobuf.elwa_v1.EudRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudRequest;
  return proto.ev24.protobuf.elwa_v1.EudRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudRequest}
 */
proto.ev24.protobuf.elwa_v1.EudRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 3:
      var value = msg.getPayloadMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPayloadMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string token = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * map<string, string> payload = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.ev24.protobuf.elwa_v1.EudRequest.prototype.getPayloadMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudRequest.prototype.clearPayloadMap = function() {
  this.getPayloadMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    username: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest}
 */
proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest;
  return proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest}
 */
proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudResetPasswordRequest.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudLoginRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudLoginRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudLoginRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudLoginRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    password: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudLoginRequest}
 */
proto.ev24.protobuf.elwa_v1.EudLoginRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudLoginRequest;
  return proto.ev24.protobuf.elwa_v1.EudLoginRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudLoginRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudLoginRequest}
 */
proto.ev24.protobuf.elwa_v1.EudLoginRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudLoginRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudLoginRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudLoginRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudLoginRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudLoginRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudLoginRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudLoginRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudLoginRequest.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudLoginRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudLoginRequest.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudLoginRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudLoginRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudLoginRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudRefreshRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudRefreshRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudRefreshRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudRefreshRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    refreshCode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudRefreshRequest}
 */
proto.ev24.protobuf.elwa_v1.EudRefreshRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudRefreshRequest;
  return proto.ev24.protobuf.elwa_v1.EudRefreshRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudRefreshRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudRefreshRequest}
 */
proto.ev24.protobuf.elwa_v1.EudRefreshRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefreshCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudRefreshRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudRefreshRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudRefreshRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudRefreshRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRefreshCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudRefreshRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudRefreshRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudRefreshRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string refresh_code = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudRefreshRequest.prototype.getRefreshCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudRefreshRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudRefreshRequest.prototype.setRefreshCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    code: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, ""),
    payloadMap: (f = msg.getPayloadMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudResponse}
 */
proto.ev24.protobuf.elwa_v1.EudResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudResponse;
  return proto.ev24.protobuf.elwa_v1.EudResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudResponse}
 */
proto.ev24.protobuf.elwa_v1.EudResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = msg.getPayloadMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPayloadMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudResponse.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudResponse.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudResponse.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * map<string, string> payload = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.ev24.protobuf.elwa_v1.EudResponse.prototype.getPayloadMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudResponse.prototype.clearPayloadMap = function() {
  this.getPayloadMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudLunaToken.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudLunaToken.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudLunaToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudLunaToken.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accessToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudLunaToken}
 */
proto.ev24.protobuf.elwa_v1.EudLunaToken.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudLunaToken;
  return proto.ev24.protobuf.elwa_v1.EudLunaToken.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudLunaToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudLunaToken}
 */
proto.ev24.protobuf.elwa_v1.EudLunaToken.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudLunaToken.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudLunaToken.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudLunaToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudLunaToken.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccessToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudLunaToken.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudLunaToken} returns this
 */
proto.ev24.protobuf.elwa_v1.EudLunaToken.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string access_token = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudLunaToken.prototype.getAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudLunaToken} returns this
 */
proto.ev24.protobuf.elwa_v1.EudLunaToken.prototype.setAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudTokenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudTokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    code: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tokensList: jspb.Message.toObjectList(msg.getTokensList(),
    proto.ev24.protobuf.elwa_v1.EudLunaToken.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenResponse}
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudTokenResponse;
  return proto.ev24.protobuf.elwa_v1.EudTokenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenResponse}
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = new proto.ev24.protobuf.elwa_v1.EudLunaToken;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.EudLunaToken.deserializeBinaryFromReader);
      msg.addTokens(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTokensList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.ev24.protobuf.elwa_v1.EudLunaToken.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated EudLunaToken tokens = 4;
 * @return {!Array<!proto.ev24.protobuf.elwa_v1.EudLunaToken>}
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.prototype.getTokensList = function() {
  return /** @type{!Array<!proto.ev24.protobuf.elwa_v1.EudLunaToken>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ev24.protobuf.elwa_v1.EudLunaToken, 4));
};


/**
 * @param {!Array<!proto.ev24.protobuf.elwa_v1.EudLunaToken>} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenResponse} returns this
*/
proto.ev24.protobuf.elwa_v1.EudTokenResponse.prototype.setTokensList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.ev24.protobuf.elwa_v1.EudLunaToken=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ev24.protobuf.elwa_v1.EudLunaToken}
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.prototype.addTokens = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.ev24.protobuf.elwa_v1.EudLunaToken, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudTokenResponse.prototype.clearTokensList = function() {
  return this.setTokensList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    code: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, ""),
    refreshCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    tokensList: jspb.Message.toObjectList(msg.getTokensList(),
    proto.ev24.protobuf.elwa_v1.EudLunaToken.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse}
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse;
  return proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse}
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefreshCode(value);
      break;
    case 5:
      var value = new proto.ev24.protobuf.elwa_v1.EudLunaToken;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.EudLunaToken.deserializeBinaryFromReader);
      msg.addTokens(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRefreshCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTokensList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.ev24.protobuf.elwa_v1.EudLunaToken.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string refresh_code = 4;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.prototype.getRefreshCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.prototype.setRefreshCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated EudLunaToken tokens = 5;
 * @return {!Array<!proto.ev24.protobuf.elwa_v1.EudLunaToken>}
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.prototype.getTokensList = function() {
  return /** @type{!Array<!proto.ev24.protobuf.elwa_v1.EudLunaToken>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ev24.protobuf.elwa_v1.EudLunaToken, 5));
};


/**
 * @param {!Array<!proto.ev24.protobuf.elwa_v1.EudLunaToken>} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse} returns this
*/
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.prototype.setTokensList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.ev24.protobuf.elwa_v1.EudLunaToken=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ev24.protobuf.elwa_v1.EudLunaToken}
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.prototype.addTokens = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.ev24.protobuf.elwa_v1.EudLunaToken, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudTokenRefreshResponse.prototype.clearTokensList = function() {
  return this.setTokensList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudLiteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudLiteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudLiteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudLiteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    code: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudLiteResponse}
 */
proto.ev24.protobuf.elwa_v1.EudLiteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudLiteResponse;
  return proto.ev24.protobuf.elwa_v1.EudLiteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudLiteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudLiteResponse}
 */
proto.ev24.protobuf.elwa_v1.EudLiteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudLiteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudLiteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudLiteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudLiteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudLiteResponse.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudLiteResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudLiteResponse.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudLiteResponse.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudLiteResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudLiteResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudLiteResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudLiteResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.EudLiteResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    orgCanonicalNames: jspb.Message.getFieldWithDefault(msg, 4, ""),
    maxUsages: jspb.Message.getFieldWithDefault(msg, 5, 0),
    currentUsages: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode;
  return proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgCanonicalNames(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxUsages(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentUsages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getOrgCanonicalNames();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMaxUsages();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getCurrentUsages();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool active = 3;
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string org_canonical_names = 4;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.prototype.getOrgCanonicalNames = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.prototype.setOrgCanonicalNames = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 max_usages = 5;
 * @return {number}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.prototype.getMaxUsages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.prototype.setMaxUsages = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 current_usages = 6;
 * @return {number}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.prototype.getCurrentUsages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.prototype.setCurrentUsages = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    orgCanonicalNames: jspb.Message.getFieldWithDefault(msg, 4, ""),
    maxUsages: jspb.Message.getFieldWithDefault(msg, 5, 0),
    currentUsages: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest;
  return proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgCanonicalNames(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxUsages(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentUsages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.setDescription = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.clearDescription = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool active = 3;
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.setActive = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.clearActive = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.hasActive = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string org_canonical_names = 4;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.getOrgCanonicalNames = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.setOrgCanonicalNames = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.clearOrgCanonicalNames = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.hasOrgCanonicalNames = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 max_usages = 5;
 * @return {number}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.getMaxUsages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.setMaxUsages = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.clearMaxUsages = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.hasMaxUsages = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 current_usages = 6;
 * @return {number}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.getCurrentUsages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.setCurrentUsages = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.clearCurrentUsages = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.prototype.hasCurrentUsages = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    token: jspb.Message.getFieldWithDefault(msg, 2, ""),
    actor: jspb.Message.getFieldWithDefault(msg, 3, ""),
    payload: (f = msg.getPayload()) && proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest;
  return proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setActor(value);
      break;
    case 4:
      var value = new proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.deserializeBinaryFromReader);
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string token = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string actor = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.prototype.getActor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.prototype.setActor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional EudUserAccountSignUpCodeRequest payload = 4;
 * @return {?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.prototype.getPayload = function() {
  return /** @type{?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest} */ (
    jspb.Message.getWrapperField(this, proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest, 4));
};


/**
 * @param {?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCodeRequest|undefined} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest} returns this
*/
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.prototype.setPayload = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.prototype.clearPayload = function() {
  return this.setPayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeRequest.prototype.hasPayload = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    code: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, ""),
    payload: (f = msg.getPayload()) && proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse;
  return proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = new proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.deserializeBinaryFromReader);
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional EudUserAccountSignUpCode payload = 4;
 * @return {?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.prototype.getPayload = function() {
  return /** @type{?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode} */ (
    jspb.Message.getWrapperField(this, proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode, 4));
};


/**
 * @param {?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode|undefined} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse} returns this
*/
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.prototype.setPayload = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.prototype.clearPayload = function() {
  return this.setPayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeResponse.prototype.hasPayload = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    code: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, ""),
    payloadList: jspb.Message.toObjectList(msg.getPayloadList(),
    proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse;
  return proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = new proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.deserializeBinaryFromReader);
      msg.addPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPayloadList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated EudUserAccountSignUpCode payload = 4;
 * @return {!Array<!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode>}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.prototype.getPayloadList = function() {
  return /** @type{!Array<!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode, 4));
};


/**
 * @param {!Array<!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode>} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse} returns this
*/
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.prototype.setPayloadList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.prototype.addPayload = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpCodeListResponse.prototype.clearPayloadList = function() {
  return this.setPayloadList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    password: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fullName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    signUpCode: (f = msg.getSignUpCode()) && proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp;
  return proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullName(value);
      break;
    case 5:
      var value = new proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.deserializeBinaryFromReader);
      msg.setSignUpCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFullName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSignUpCode();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode.serializeBinaryToWriter
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string full_name = 4;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.prototype.getFullName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.prototype.setFullName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional EudUserAccountSignUpCode sign_up_code = 5;
 * @return {?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.prototype.getSignUpCode = function() {
  return /** @type{?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode} */ (
    jspb.Message.getWrapperField(this, proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode, 5));
};


/**
 * @param {?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUpCode|undefined} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp} returns this
*/
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.prototype.setSignUpCode = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.prototype.clearSignUpCode = function() {
  return this.setSignUpCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.prototype.hasSignUpCode = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    recaptchaToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
    payload: (f = msg.getPayload()) && proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest;
  return proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecaptchaToken(value);
      break;
    case 4:
      var value = new proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.deserializeBinaryFromReader);
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRecaptchaToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string recaptcha_token = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.prototype.getRecaptchaToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.prototype.setRecaptchaToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional EudUserAccountSignUp payload = 4;
 * @return {?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.prototype.getPayload = function() {
  return /** @type{?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp} */ (
    jspb.Message.getWrapperField(this, proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp, 4));
};


/**
 * @param {?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp|undefined} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest} returns this
*/
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.prototype.setPayload = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.prototype.clearPayload = function() {
  return this.setPayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpRequest.prototype.hasPayload = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    code: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, ""),
    payload: (f = msg.getPayload()) && proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse;
  return proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = new proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.deserializeBinaryFromReader);
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional EudUserAccountSignUp payload = 4;
 * @return {?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.prototype.getPayload = function() {
  return /** @type{?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp} */ (
    jspb.Message.getWrapperField(this, proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp, 4));
};


/**
 * @param {?proto.ev24.protobuf.elwa_v1.EudUserAccountSignUp|undefined} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse} returns this
*/
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.prototype.setPayload = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.prototype.clearPayload = function() {
  return this.setPayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.E24UserAccountSignUpResponse.prototype.hasPayload = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudRequestDashboards.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudRequestDashboards.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudRequestDashboards} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudRequestDashboards.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    token: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudRequestDashboards}
 */
proto.ev24.protobuf.elwa_v1.EudRequestDashboards.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudRequestDashboards;
  return proto.ev24.protobuf.elwa_v1.EudRequestDashboards.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudRequestDashboards} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudRequestDashboards}
 */
proto.ev24.protobuf.elwa_v1.EudRequestDashboards.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudRequestDashboards.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudRequestDashboards.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudRequestDashboards} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudRequestDashboards.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudRequestDashboards.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudRequestDashboards} returns this
 */
proto.ev24.protobuf.elwa_v1.EudRequestDashboards.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string token = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudRequestDashboards.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudRequestDashboards} returns this
 */
proto.ev24.protobuf.elwa_v1.EudRequestDashboards.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudUiDisplay.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudUiDisplay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudUiDisplay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudUiDisplay.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    optionsMap: (f = msg.getOptionsMap()) ? f.toObject(includeInstance, undefined) : [],
    optionsReportDefOverrideMap: (f = msg.getOptionsReportDefOverrideMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDisplay}
 */
proto.ev24.protobuf.elwa_v1.EudUiDisplay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudUiDisplay;
  return proto.ev24.protobuf.elwa_v1.EudUiDisplay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudUiDisplay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDisplay}
 */
proto.ev24.protobuf.elwa_v1.EudUiDisplay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = msg.getOptionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 3:
      var value = msg.getOptionsReportDefOverrideMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudUiDisplay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudUiDisplay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudUiDisplay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudUiDisplay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOptionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getOptionsReportDefOverrideMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUiDisplay.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDisplay} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUiDisplay.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * map<string, string> options = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.ev24.protobuf.elwa_v1.EudUiDisplay.prototype.getOptionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDisplay} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUiDisplay.prototype.clearOptionsMap = function() {
  this.getOptionsMap().clear();
  return this;
};


/**
 * map<string, string> options_report_def_override = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.ev24.protobuf.elwa_v1.EudUiDisplay.prototype.getOptionsReportDefOverrideMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDisplay} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUiDisplay.prototype.clearOptionsReportDefOverrideMap = function() {
  this.getOptionsReportDefOverrideMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudFieldDef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudFieldDef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, ""),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    valueJson: jspb.Message.getFieldWithDefault(msg, 4, ""),
    optionsMap: (f = msg.getOptionsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudFieldDef}
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudFieldDef;
  return proto.ev24.protobuf.elwa_v1.EudFieldDef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudFieldDef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudFieldDef}
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValueJson(value);
      break;
    case 5:
      var value = msg.getOptionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudFieldDef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudFieldDef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getValueJson();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOptionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudFieldDef} returns this
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudFieldDef} returns this
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudFieldDef} returns this
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string value_json = 4;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.prototype.getValueJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudFieldDef} returns this
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.prototype.setValueJson = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * map<string, string> options = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.prototype.getOptionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudFieldDef} returns this
 */
proto.ev24.protobuf.elwa_v1.EudFieldDef.prototype.clearOptionsMap = function() {
  this.getOptionsMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudReportDef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudReportDef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dataType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    title: jspb.Message.getFieldWithDefault(msg, 4, ""),
    description: jspb.Message.getFieldWithDefault(msg, 5, ""),
    optionsMap: (f = msg.getOptionsMap()) ? f.toObject(includeInstance, undefined) : [],
    filterDefsList: jspb.Message.toObjectList(msg.getFilterDefsList(),
    proto.ev24.protobuf.elwa_v1.EudFieldDef.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudReportDef}
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudReportDef;
  return proto.ev24.protobuf.elwa_v1.EudReportDef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudReportDef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudReportDef}
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = msg.getOptionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 7:
      var value = new proto.ev24.protobuf.elwa_v1.EudFieldDef;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.EudFieldDef.deserializeBinaryFromReader);
      msg.addFilterDefs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudReportDef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudReportDef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDataType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOptionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getFilterDefsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.ev24.protobuf.elwa_v1.EudFieldDef.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudReportDef} returns this
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudReportDef} returns this
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string data_type = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.getDataType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudReportDef} returns this
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.setDataType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudReportDef} returns this
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudReportDef} returns this
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * map<string, string> options = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.getOptionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudReportDef} returns this
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.clearOptionsMap = function() {
  this.getOptionsMap().clear();
  return this;
};


/**
 * repeated EudFieldDef filter_defs = 7;
 * @return {!Array<!proto.ev24.protobuf.elwa_v1.EudFieldDef>}
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.getFilterDefsList = function() {
  return /** @type{!Array<!proto.ev24.protobuf.elwa_v1.EudFieldDef>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ev24.protobuf.elwa_v1.EudFieldDef, 7));
};


/**
 * @param {!Array<!proto.ev24.protobuf.elwa_v1.EudFieldDef>} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudReportDef} returns this
*/
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.setFilterDefsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.ev24.protobuf.elwa_v1.EudFieldDef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ev24.protobuf.elwa_v1.EudFieldDef}
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.addFilterDefs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.ev24.protobuf.elwa_v1.EudFieldDef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudReportDef} returns this
 */
proto.ev24.protobuf.elwa_v1.EudReportDef.prototype.clearFilterDefsList = function() {
  return this.setFilterDefsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudUiDashboard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudUiDashboard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, ""),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    optionsMap: (f = msg.getOptionsMap()) ? f.toObject(includeInstance, undefined) : [],
    uiDisplaysList: jspb.Message.toObjectList(msg.getUiDisplaysList(),
    proto.ev24.protobuf.elwa_v1.EudUiDisplay.toObject, includeInstance),
    reportDefsList: jspb.Message.toObjectList(msg.getReportDefsList(),
    proto.ev24.protobuf.elwa_v1.EudReportDef.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDashboard}
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudUiDashboard;
  return proto.ev24.protobuf.elwa_v1.EudUiDashboard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudUiDashboard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDashboard}
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = msg.getOptionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 6:
      var value = new proto.ev24.protobuf.elwa_v1.EudUiDisplay;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.EudUiDisplay.deserializeBinaryFromReader);
      msg.addUiDisplays(value);
      break;
    case 7:
      var value = new proto.ev24.protobuf.elwa_v1.EudReportDef;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.EudReportDef.deserializeBinaryFromReader);
      msg.addReportDefs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudUiDashboard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudUiDashboard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOptionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getUiDisplaysList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.ev24.protobuf.elwa_v1.EudUiDisplay.serializeBinaryToWriter
    );
  }
  f = message.getReportDefsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.ev24.protobuf.elwa_v1.EudReportDef.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDashboard} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDashboard} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDashboard} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDashboard} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * map<string, string> options = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.getOptionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDashboard} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.clearOptionsMap = function() {
  this.getOptionsMap().clear();
  return this;
};


/**
 * repeated EudUiDisplay ui_displays = 6;
 * @return {!Array<!proto.ev24.protobuf.elwa_v1.EudUiDisplay>}
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.getUiDisplaysList = function() {
  return /** @type{!Array<!proto.ev24.protobuf.elwa_v1.EudUiDisplay>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ev24.protobuf.elwa_v1.EudUiDisplay, 6));
};


/**
 * @param {!Array<!proto.ev24.protobuf.elwa_v1.EudUiDisplay>} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDashboard} returns this
*/
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.setUiDisplaysList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.ev24.protobuf.elwa_v1.EudUiDisplay=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDisplay}
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.addUiDisplays = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.ev24.protobuf.elwa_v1.EudUiDisplay, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDashboard} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.clearUiDisplaysList = function() {
  return this.setUiDisplaysList([]);
};


/**
 * repeated EudReportDef report_defs = 7;
 * @return {!Array<!proto.ev24.protobuf.elwa_v1.EudReportDef>}
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.getReportDefsList = function() {
  return /** @type{!Array<!proto.ev24.protobuf.elwa_v1.EudReportDef>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ev24.protobuf.elwa_v1.EudReportDef, 7));
};


/**
 * @param {!Array<!proto.ev24.protobuf.elwa_v1.EudReportDef>} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDashboard} returns this
*/
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.setReportDefsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.ev24.protobuf.elwa_v1.EudReportDef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ev24.protobuf.elwa_v1.EudReportDef}
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.addReportDefs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.ev24.protobuf.elwa_v1.EudReportDef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDashboard} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUiDashboard.prototype.clearReportDefsList = function() {
  return this.setReportDefsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudResponseDashboards.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudResponseDashboards} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    code: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, ""),
    payloadList: jspb.Message.toObjectList(msg.getPayloadList(),
    proto.ev24.protobuf.elwa_v1.EudUiDashboard.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudResponseDashboards}
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudResponseDashboards;
  return proto.ev24.protobuf.elwa_v1.EudResponseDashboards.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudResponseDashboards} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudResponseDashboards}
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = new proto.ev24.protobuf.elwa_v1.EudUiDashboard;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.EudUiDashboard.deserializeBinaryFromReader);
      msg.addPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudResponseDashboards.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudResponseDashboards} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPayloadList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.ev24.protobuf.elwa_v1.EudUiDashboard.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudResponseDashboards} returns this
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudResponseDashboards} returns this
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudResponseDashboards} returns this
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated EudUiDashboard payload = 4;
 * @return {!Array<!proto.ev24.protobuf.elwa_v1.EudUiDashboard>}
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.prototype.getPayloadList = function() {
  return /** @type{!Array<!proto.ev24.protobuf.elwa_v1.EudUiDashboard>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ev24.protobuf.elwa_v1.EudUiDashboard, 4));
};


/**
 * @param {!Array<!proto.ev24.protobuf.elwa_v1.EudUiDashboard>} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudResponseDashboards} returns this
*/
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.prototype.setPayloadList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.ev24.protobuf.elwa_v1.EudUiDashboard=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ev24.protobuf.elwa_v1.EudUiDashboard}
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.prototype.addPayload = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.ev24.protobuf.elwa_v1.EudUiDashboard, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudResponseDashboards} returns this
 */
proto.ev24.protobuf.elwa_v1.EudResponseDashboards.prototype.clearPayloadList = function() {
  return this.setPayloadList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest}
 */
proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest;
  return proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest}
 */
proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.EudForgotUsernameRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudUserFeedback.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserFeedback} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.toObject = function(includeInstance, msg) {
  var f, obj = {
    comment: jspb.Message.getFieldWithDefault(msg, 1, ""),
    relatedTo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    metaMap: (f = msg.getMetaMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserFeedback}
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudUserFeedback;
  return proto.ev24.protobuf.elwa_v1.EudUserFeedback.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserFeedback} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserFeedback}
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelatedTo(value);
      break;
    case 3:
      var value = msg.getMetaMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudUserFeedback.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserFeedback} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMetaMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string comment = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserFeedback} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.prototype.setComment = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserFeedback} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.prototype.clearComment = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.prototype.hasComment = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string related_to = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.prototype.getRelatedTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserFeedback} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.prototype.setRelatedTo = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserFeedback} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.prototype.clearRelatedTo = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.prototype.hasRelatedTo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * map<string, string> meta = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.prototype.getMetaMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserFeedback} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserFeedback.prototype.clearMetaMap = function() {
  this.getMetaMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    token: jspb.Message.getFieldWithDefault(msg, 2, ""),
    recaptchaToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
    payload: (f = msg.getPayload()) && proto.ev24.protobuf.elwa_v1.EudUserFeedback.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest}
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest;
  return proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest}
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecaptchaToken(value);
      break;
    case 4:
      var value = new proto.ev24.protobuf.elwa_v1.EudUserFeedback;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.EudUserFeedback.deserializeBinaryFromReader);
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRecaptchaToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ev24.protobuf.elwa_v1.EudUserFeedback.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string token = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string recaptcha_token = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.prototype.getRecaptchaToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.prototype.setRecaptchaToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional EudUserFeedback payload = 4;
 * @return {?proto.ev24.protobuf.elwa_v1.EudUserFeedback}
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.prototype.getPayload = function() {
  return /** @type{?proto.ev24.protobuf.elwa_v1.EudUserFeedback} */ (
    jspb.Message.getWrapperField(this, proto.ev24.protobuf.elwa_v1.EudUserFeedback, 4));
};


/**
 * @param {?proto.ev24.protobuf.elwa_v1.EudUserFeedback|undefined} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest} returns this
*/
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.prototype.setPayload = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.prototype.clearPayload = function() {
  return this.setPayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.E24UserFeedbackRequest.prototype.hasPayload = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.EudUserSupport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserSupport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fullname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    problem: jspb.Message.getFieldWithDefault(msg, 3, ""),
    relatedTo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    metaMap: (f = msg.getMetaMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserSupport}
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.EudUserSupport;
  return proto.ev24.protobuf.elwa_v1.EudUserSupport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserSupport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserSupport}
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProblem(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelatedTo(value);
      break;
    case 5:
      var value = msg.getMetaMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.EudUserSupport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.EudUserSupport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProblem();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMetaMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserSupport} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.setEmail = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserSupport} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.clearEmail = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string fullname = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.getFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserSupport} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.setFullname = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserSupport} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.clearFullname = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.hasFullname = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string problem = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.getProblem = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserSupport} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.setProblem = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string related_to = 4;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.getRelatedTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserSupport} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.setRelatedTo = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserSupport} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.clearRelatedTo = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.hasRelatedTo = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * map<string, string> meta = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.getMetaMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.ev24.protobuf.elwa_v1.EudUserSupport} returns this
 */
proto.ev24.protobuf.elwa_v1.EudUserSupport.prototype.clearMetaMap = function() {
  this.getMetaMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserSupportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    token: jspb.Message.getFieldWithDefault(msg, 2, ""),
    recaptchaToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
    payload: (f = msg.getPayload()) && proto.ev24.protobuf.elwa_v1.EudUserSupport.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserSupportRequest}
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ev24.protobuf.elwa_v1.E24UserSupportRequest;
  return proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserSupportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserSupportRequest}
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecaptchaToken(value);
      break;
    case 4:
      var value = new proto.ev24.protobuf.elwa_v1.EudUserSupport;
      reader.readMessage(value,proto.ev24.protobuf.elwa_v1.EudUserSupport.deserializeBinaryFromReader);
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ev24.protobuf.elwa_v1.E24UserSupportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRecaptchaToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ev24.protobuf.elwa_v1.EudUserSupport.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserSupportRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string token = 2;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserSupportRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string recaptcha_token = 3;
 * @return {string}
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.prototype.getRecaptchaToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserSupportRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.prototype.setRecaptchaToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional EudUserSupport payload = 4;
 * @return {?proto.ev24.protobuf.elwa_v1.EudUserSupport}
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.prototype.getPayload = function() {
  return /** @type{?proto.ev24.protobuf.elwa_v1.EudUserSupport} */ (
    jspb.Message.getWrapperField(this, proto.ev24.protobuf.elwa_v1.EudUserSupport, 4));
};


/**
 * @param {?proto.ev24.protobuf.elwa_v1.EudUserSupport|undefined} value
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserSupportRequest} returns this
*/
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.prototype.setPayload = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ev24.protobuf.elwa_v1.E24UserSupportRequest} returns this
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.prototype.clearPayload = function() {
  return this.setPayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ev24.protobuf.elwa_v1.E24UserSupportRequest.prototype.hasPayload = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.ev24.protobuf.elwa_v1);
